<template>
    <div class="wrap">
        <h4>销单管理-表现分管理</h4>
        <p>配置表现分扣除条件及恢复表现分条件</p>

        <el-form ref="form" :model="submit_data" label-width="80px" class="form-wrap-sales">
            <el-form-item label="开关" label-width='200px'>

                <el-switch
                        v-model="submit_data.status"
                        active-color="#05C0AB"
                        active-value="1"
                        inactive-value="0"
                        inactive-color="#ff4949">
                </el-switch>


            </el-form-item>

            <el-form-item label="取消订单次数" label-width='200px'>

                <el-input v-model="submit_data.base_num"></el-input>

                <span>达到配置次数，表现分-1;每超一单表现分-1;不配置默认为0,不扣表现分</span>

            </el-form-item>
            <el-form-item label="扣除表现分" label-width='200px'>

                <el-input v-model="submit_data.sub_monitor"></el-input>

                <span>不配置默认为0,不扣表现分</span>

            </el-form-item>
            <el-form-item label="扣分上限" label-width='200px'>

                <el-input v-model="submit_data.sub_top"></el-input>

                <span>设置扣分上限,当扣分达到配置的数值时将不再扣除表现分</span>

            </el-form-item>
            <el-form-item label="连续完成订单恢复所扣表现分" label-width='200px'>

                <el-input v-model="submit_data.reset_num"></el-input>

                <span>
                    “连续”完成配置数值的订单数可恢复所扣表现分,若连续完成订单数不足配置数值,取消了一单后
                    再继续完成订单则取消前的订单数量作废重新计算连续完成订单数
                </span>

            </el-form-item>
        </el-form>


        <el-button type="primary" class="submit-btn" @click="onSubmit">保存</el-button>

    </div>
</template>

<script>
    let _this;
    export default {
        data(){
            return {
                submit_data:{},
                submit_rules:{
                    base_num: {
                        placeholder: '取消订单次数',
                        rules: {
                            required: true,
                            message: '取消订单次数需大于等于0',
                            regulation: 'egt',
                            rulesData: 0
                        }
                    },
                    sub_monitor: {
                        placeholder: '扣除表现分',
                        rules: {
                            required: true,
                            message: '扣除表现分需大于等于0',
                            regulation: 'egt',
                            rulesData: 0
                        }
                    },
                    sub_top: {
                        placeholder: '扣分上限',
                        rules: {
                            required: true,
                            message: '扣分上限需大于等于0',
                            regulation: 'egt',
                            rulesData: 0
                        }
                    },
                    reset_num :{
                        placeholder: '连续完成订单恢复所扣表现分',
                        rules: {
                            required: true,
                            message: '连续完成订单恢复所扣表现分需大于等于0',
                            regulation: 'egt',
                            rulesData: 0
                        }
                    }
                }
            }
        },
        created() {
            _this = this;

            // 获取销单配置

            _this.getMonitorConf()

        },
        methods:{
            getMonitorConf(){
                _this.$post(
                    "/monitor/monitorConf"
                ).then(res => {
                    _this.submit_data = res.data;
                })
            },
            onSubmit(){
                _this.$post(
                    "/monitor/editMonitor",
                    _this.submit_data,
                    _this.submit_rules
                ).then(res => {
                    _this.$message.success('修改成功');
                    _this.getMonitorConf()
                })
            }
        }

    };
</script>

<style scoped>
    .wrap{
        width: 100%;
        height: 100%;
        background-color: #FFFFFF;
        padding: 50px 0 0 20px;
        box-sizing: border-box;
    }
    .wrap h4{
        font-size: 28px;
        padding-left: 120px;
        margin-bottom: 10px;
    }
    .wrap p{
        font-size: 16px;
        padding-left: 120px;
        color: #999999;
    }
    .form-wrap-sales{
        margin-top: 50px;
    }
    .el-input{
        width: 100px;
        margin-right: 20px;
    }

    .form-wrap-sales span{
        display: block;
        max-width: 500px;
        color: #999999;
    }
    .submit-btn{
        margin-left: 200px;
    }
</style>
<style>
    .form-wrap-sales .el-form-item__content{
        display: flex;
    }
</style>
